import { useEffect, useState } from "react";
import { base64ToUrl } from "./common";
import { getCachedImage, loadImage } from "./imageBatchLoader";

export function useImageUrl(imageId: string | undefined): string | null {
    const [url, setUrl] = useState<string | null>(() =>
        imageId ? (getCachedImage(imageId) ?? null) : null
    );

    useEffect(() => {
        if (!imageId) {
            setUrl(null);
            return () => {};
        }

        const cached = getCachedImage(imageId);
        if (cached !== undefined) {
            setUrl(cached);
            return () => {};
        }

        setUrl(null);
        return loadImage(imageId, setUrl);
    }, [imageId]);

    return url;
}

export function usePersonInfoImageUrl(info: { photo?: string | null; imageId?: string } | undefined): string | null {
    if (info?.photo) {
        return base64ToUrl(info.photo) ?? null;
    }

    return useImageUrl(info?.imageId);
}
